module.exports = "/_next/static/images/2a7991fc49a4453f1bc740389cce2267-holding-card-vertical@0.5x.png";